import React from "react";
import styles from './CompanyAutoCompleteInput.module.scss';

import {Autocomplete} from '@material-ui/lab';
import {CircularProgress, TextField} from '@material-ui/core';
import {ICompanyPrediction} from "data/interfaces/products";
import FormErrorDisplay from 'gui/components/formErrorDisplay';

export interface ICompanySelectorProps {
  label: string;
  field?: any;
  queryCompany: (query) => Promise<ICompanyPrediction[]>;
  form: any;
}


const CompanyAutoCompleteInput = (props: ICompanySelectorProps) => {
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState<any[]>([]);
  const touched = props.form.touched[props.field.name];
  const error = touched && props.form.errors[props.field.name] && props.form.errors[props.field.name].name;
  const value = props.field.value;
  const valid = touched && !error;
  return (
    <>
      <Autocomplete
        id={props.field.name}
        freeSolo
        autoComplete={true}
        autoHighlight={true}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name || ''}
        options={options}
        loading={loading}
        loadingText={'טוען...'}
        noOptionsText={''}
        value={props.field.value}
        className={`${styles.companySelector} ${error ? styles.error : ''} ${valid ? styles.valid : ''}`.trim()}

        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant="outlined"
            fullWidth={true}
            inputRef={ref => {
              if (ref && ref.setAttribute) {
                ref.setAttribute("maxLength", 50);
              }
              return ref;
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20}/> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            {...props.field}
            onChange={async (e) => {
              const value = e.target.value;
              if (props.field && props.field.onChange) {
                await props.field.onChange({
                  target: {
                    name: props.field.name,
                    value: {name: value}
                  },
                });
              }
              setLoading(true)
              props.queryCompany(value)
                .then((companies: any) => {
                  setOptions(companies);
                  setLoading(false);
                })
                .catch(e => {
                  console.log(e);
                  setLoading(false);
                  return Promise.resolve();
                });
            }}
            onBlur={async (e) => {
              if (props.field && props.field.onChange) {
                await props.field.onBlur(e);
              }
              if (options.length > 0 && props.field.value && props.field.value.name && !props.field.value.id) {
                const _name = props.field.value.name.toUpperCase();
                const inListValue = options.find(({name}) => name.toUpperCase().startsWith(_name));
                if (inListValue) {
                  await props.field.onChange({
                    target: {
                      name: props.field.name,
                      value: inListValue
                    },
                  });
                }
              }
            }}
          />
        )}

        onChange={(e, _value) => {
          if (_value) {
            const {name, id} = _value;
            const value = name;
            if (props.field && props.field.onChange) {
              props.field.onChange({
                target: {
                  name: props.field.name,
                  value: {id, name: value}
                },
              });
            }
          }
        }}
      />
      <FormErrorDisplay error={error}/>
    </>
  );
};

CompanyAutoCompleteInput.defaultProps =
  {
    queryCompany: () => Promise.resolve(),
  };

export default CompanyAutoCompleteInput;
